export default {
  state: {
    popupEmailShown: false,
    hasTopNavbarBgImage: false,
  },
  mutations: {
    SET_POPUP_EMAIL_SHOWN(state, payload) {
      console.log('Inside SET_POPUP_EMAIL_SHOWN - payload', payload)
      state.popupEmailShown = payload
    },
    SET_HAS_TOP_NAVBAR_BG_IMAGE(state, payload) {
      state.hasTopNavbarBgImage = payload
    },
  },
  getters: {
    GET_POPUP_EMAIL_SHOWN(state) {
      return state.popupEmailShown
    },
    GET_HAS_TOP_NAVBAR_BG_IMAGE(state) {
      return state.hasTopNavbarBgImage
    },
  },
}
